import firebase from "firebase/app";
import "firebase/auth";
import { reloadAxios, sendPost } from "@/util/api";

const getLoggedInUser = () => {
  if (localStorage.getItem("userInfo") != null) {
    return JSON.parse(localStorage.getItem("userInfo"));
  } else if (sessionStorage.getItem("userInfo") != null) {
    return JSON.parse(sessionStorage.getItem("userInfo"));
  }
  return null;
}

export default {
  state: {
    loggedInUser: getLoggedInUser(),
    loading: false,
    loadingSpinnerText: '',
    error: null,
    snackbarMessage: '',
  },
  getters: {
    loggedInUser: state => state.loggedInUser,
    loading: state => state.loading,
    loadingSpinnerText: state => state.loadingSpinnerText,
    error: state => state.error,
    snackbarMessage: state => state.snackbarMessage
  },
  mutations: {
    setUser(state, data) {
      state.loggedInUser = data;
      state.loading = false;
      state.error = null;
    },
    setLogout(state) {
      state.loggedInUser = null;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, data) {
      state.loading = data;
      state.error = null;
    },
    setLoadingSpinnerText(state, data) {
      state.loadingSpinnerText = data;
    },
    setError(state, data) {
      state.error = data;
      state.loggedInUser = null;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
    setSnackbarMessage(state, message) {
      state.snackbarMessage = message;
    }
  },
  actions: {
    login({ commit }, { username, password, saveSession }) {
      commit("clearError");
      commit("setLoading", true);
      sendPost('auth/token/login', { username, password })
        .then(({ auth_token: authToken }) => {
          const newUser = { uid: authToken, username };
          localStorage.setItem('userInfo', JSON.stringify(newUser));
          commit("setUser", newUser);
          reloadAxios();
          commit("setLoading", false);
        })
        .catch(function(error) {
          // Handle Errors here.
          // var errorCode = error.code;
          // var errorMessage = error.message;
          localStorage.removeItem("userInfo");
          sessionStorage.removeItem("userInfo");
          commit('setError', 'Username or Password is incorrect');
        });
    },
    signUserUp({ commit }, data) {
      commit("setLoading", true);
      commit("clearError");
      firebase
        .auth()
        .createUserWithEmailAndPassword(data.email, data.password)
        .then(user => {
          commit("setLoading", false);
          const newUser = {
            uid: user.user.uid
          };
          console.log(newUser);
          localStorage.setItem("userInfo", JSON.stringify(newUser));
          commit("setUser", newUser);
        })
        .catch(error => {
          commit("setLoading", false);
          commit("setError", error);
          localStorage.removeItem("userInfo");
          console.log(error);
        });
    },
    signOut({ commit }) {
      commit("setLoading", true);
      commit("clearError");
      localStorage.removeItem("userInfo");
      sessionStorage.removeItem("userInfo");
      sendPost('auth/token/logout')
        .then(() => {
            commit("setLoading", false);
            reloadAxios(false);
            commit("setLogout");
          },
          _error => {
            commit("setLoading", false);
            reloadAxios(false);
            commit("setLogout");
          }
        )
        .catch(function(error) {
          commit("setLoading", false);
          reloadAxios(false);
        });
    },
    setLoading({ commit }, data) {
      commit("setLoading", data);
    },
    setLoadingSpinnerText({ commit }, data) {
      commit("setLoadingSpinnerText", data);
    },
    setSnackbarMessage({ commit }, message) {
      commit("setSnackbarMessage", message);
    },
  }
};
